var nlDateString = function(date) {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    let newDate = (new Date(new Date(date) - tzoffset));
    let month = newDate.getMonth();
    month = `${(month + 1)}`;
    if(month.length == 1) {
    	month = `0${month}`;
    }

    return `${newDate.getDate()}-${month}-${newDate.getFullYear()}`
};

export default nlDateString;